export default {
  NEW_USER_NO_SYNC: "NEW_USER_NO_SYNC",
  NEW_USER_WITH_SYNC: "NEW_USER_WITH_SYNC",
  EXISTING_USER_NO_SYNC: "EXISTING_USER_NO_SYNC",
  EXISTING_USER_WITH_SYNC: "EXISTING_USER_WITH_SYNC",
  MURDER_EXAMPLE: "MURDER_EXAMPLE"
};
